module.exports = __webpack_public_path__ + "static/media/210-Mitpatient_ID_19.d08f973c.mp3";